import { FC } from 'react';
// components
import EditSubProductTypeComponent from 'components/main/SubProductType/Edit';

const EditSubProductType: FC = () => <EditSubProductTypeComponent />;

export default EditSubProductType;
